// LV1 Brand Portfolio Data

export const brands = [
  {
    slug: 'ann-taylor',
    name: 'Ann Taylor',
    type: 'licensed',
    genderProgram: 'Women\'s',
    positioning: 'Classic, timeless, polished everyday refinement',
    hero: {
      eyebrow: 'Classic Polish',
      headline: 'Timeless silhouettes built for real life',
      subhead: 'Refined, versatile footwear rooted in everyday sophistication and clean styling.',
      badges: ['Timeless', 'Versatile'],
    },
    sections: {
      background: 'Ann Taylor is about classic polish. The product is designed to be versatile, refined, and easy to wear across work, events, and everyday life.',
      vision: 'Create wardrobe-staple footwear that lasts beyond a single trend cycle. Clean shapes, balanced proportion, and reliable versatility.',
      marketing: 'We market around simplicity and confidence. Clear, clean imagery and storylines that communicate versatility. We emphasize styling across multiple outfits so the customer sees repeat value.',
      retailFit: 'Excellent for department and off-price programs where classic, polished product needs to feel dependable and easy to shop.',
    },
    cta: {
      title: 'Interested in Ann Taylor programs?',
      body: 'We\'ll share seasonal direction and recommended assortments based on your customer and channel.',
      buttonText: 'Contact Us',
    },
    coverImage: '/brands/brand-cards/ann-taylor.jpg',
    logoImage: '/brands/logos/ann-taylor.png',
    // Theme colors - Classic navy, professional, timeless
    accentColor: '#5B7A99',
    tintColor: '#3d5a7a',      // Rich navy blue tint
    glowColor: '#6B8AA9',
  },
  {
    slug: 'hurley',
    name: 'Hurley',
    type: 'licensed',
    genderProgram: 'Kids (Boys + Girls)',
    positioning: 'Sporty, trend-forward, energy-driven',
    hero: {
      eyebrow: 'Kids Athletic',
      headline: 'Sport-first style for everyday kids',
      subhead: 'Athleisure-inspired footwear with bold energy, current trends, and easy wearability.',
      badges: ['Athletic', 'Trend-Forward'],
    },
    sections: {
      background: 'Hurley for kids is built around movement. We use an athletic base and update it with trend-right tooling, textures, and color pops so the product feels current without losing everyday comfort.',
      vision: 'Create kids footwear that looks fast and modern, but still feels simple to grab, wear, and repeat. The goal is energy, ease, and strong shelf presence.',
      marketing: 'We market Hurley with sport-lifestyle storytelling. Clean, high-contrast visuals, motion-led creative, and assortment naming that makes shopping easy. We build seasonal capsules and highlight key looks that feel right for back-to-school, spring refresh, and holiday gifting.',
      retailFit: 'Great fit for mass, family footwear, sporting-goods adjacencies, and off-price programs that want athletic styling with broad commercial appeal.',
    },
    cta: {
      title: 'Interested in Hurley kids programs?',
      body: 'Reach out and we\'ll share direction, silhouettes, and how we build assortments by season and channel.',
      buttonText: 'Contact Us',
    },
    coverImage: '/brands/brand-cards/hurley.jpg',
    logoImage: '/brands/logos/hurley.png',
    // Theme colors - Ocean energy, coral accent, cool water backdrop
    accentColor: '#E07850',
    tintColor: '#2a4a5a',      // Ocean blue-gray tint
    glowColor: '#E07850',
  },
  {
    slug: 'tahari',
    name: 'Tahari',
    type: 'licensed',
    genderProgram: 'Kids (Boys + Girls) + Men\'s',
    positioning: 'Polished, versatile, clean and elevated',
    hero: {
      eyebrow: 'Everyday Elevated',
      headline: 'Clean, versatile footwear that fits the moment',
      subhead: 'Polished silhouettes designed for school, events, and dress-casual needs across kids and men\'s.',
      badges: ['Polished', 'Versatile'],
    },
    sections: {
      background: 'Tahari footwear is built to be dependable and elevated. The styling is clean and wearable, designed to work across multiple occasions while staying comfortable and commercial.',
      vision: 'Offer refined footwear that feels appropriate in more places. Easy to style, easy to buy, easy to replenish. Strong basics with seasonal updates.',
      marketing: 'We focus on clarity. Simple style stories, clean imagery, and product naming that communicates use cases quickly. We also support coordinated looks across categories so the assortment merchandises as a cohesive collection.',
      retailFit: 'Fits well in department, family footwear, mass programs, and off-price assortments where polished product needs to stay accessible and reliable.',
    },
    cta: {
      title: 'Looking for Tahari assortments?',
      body: 'We can walk you through seasonal direction and how we tailor the mix by channel.',
      buttonText: 'Contact Us',
    },
    coverImage: '/brands/brand-cards/tahari.jpg',
    logoImage: '/brands/logos/tahari.png',
    // Theme colors - Warm gold, elegant fashion
    accentColor: '#C9A86C',
    tintColor: '#5a4a35',      // Warm sepia/gold tint
    glowColor: '#D4B87C',
  },
  {
    slug: 'nicole-miller',
    name: 'Nicole Miller',
    type: 'licensed',
    genderProgram: 'Women\'s',
    positioning: 'Elegant, sophisticated, wearable fashion',
    hero: {
      eyebrow: 'Women\'s Fashion',
      headline: 'Elevated style that stays wearable',
      subhead: 'Sophisticated silhouettes with fashion-forward details that still feel easy and commercial.',
      badges: ['Elegant', 'Wearable'],
    },
    sections: {
      background: 'Nicole Miller is designed for the customer who wants something elevated without feeling overdone. The product reads polished, fashion-led, and confident at shelf.',
      vision: 'Blend sophistication with daily wearability. Modern shapes, clean refinement, and details that feel intentional and current.',
      marketing: 'We lean into premium presentation. Clean typography, refined imagery, and styling that shows the product in a real wardrobe context. We build stories around seasonal moments and highlight hero styles that anchor the assortment.',
      retailFit: 'Strong fit for department, better family footwear, off-price programs that want an elevated look, and retailers looking for fashion credibility without extreme risk.',
    },
    cta: {
      title: 'Want to explore Nicole Miller?',
      body: 'Tell us your channel and customer, and we\'ll recommend the right silhouettes and price architecture.',
      buttonText: 'Contact Us',
    },
    coverImage: '/brands/brand-cards/nicole-miller.jpg',
    logoImage: '/brands/logos/nicole-miller.png',
    // Theme colors - Warm champagne, sophisticated bronze
    accentColor: '#B8849A',
    tintColor: '#6a5548',      // Warm amber/bronze tint
    glowColor: '#D4A57A',
  },
  {
    slug: 'catherine-malandrino',
    name: 'Catherine Malandrino',
    type: 'licensed',
    genderProgram: 'Women\'s + Select Kids Programs',
    positioning: 'Chic, contemporary, trend-right, commercial',
    hero: {
      eyebrow: 'Chic + Contemporary',
      headline: 'Modern silhouettes with on-trend detail',
      subhead: 'Fashion-forward design that stays commercial, built for modern wardrobes and seasonal moments.',
      badges: ['Contemporary', 'On-Trend'],
    },
    sections: {
      background: 'Catherine Malandrino balances runway-inspired energy with practical commercial execution. The product reads modern, clean, and styled without feeling costume.',
      vision: 'Deliver contemporary fashion that feels relevant right now. Updated proportions, refined materials, and trend cues that still sell at scale.',
      marketing: 'We market with a modern editorial feel. Strong silhouettes, clean layouts, and story-led drops tied to seasonal trend moments. We also emphasize styling and outfit pairing so the customer understands how to wear it.',
      retailFit: 'Fits well across department, off-price, and select family-footwear programs that want a sharper fashion point of view.',
    },
    cta: {
      title: 'Interested in Catherine Malandrino?',
      body: 'We can share brand direction, seasonal concepts, and recommended assortment frameworks.',
      buttonText: 'Contact Us',
    },
    coverImage: '/brands/brand-cards/catherine-malandrino.jpg',
    logoImage: '/brands/logos/catherine-malandrino.png',
    // Theme colors - Wine/plum, chic contemporary
    accentColor: '#8B5A6B',
    tintColor: '#5a3a4a',      // Wine/plum tint
    glowColor: '#A06878',
  },
  {
    slug: 'taryn-rose',
    name: 'Taryn Rose',
    type: 'licensed',
    genderProgram: 'Women\'s (Comfort-Driven)',
    positioning: 'Comfort-first with a polished look',
    hero: {
      eyebrow: 'Comfort Elevated',
      headline: 'Polished comfort you can wear all day',
      subhead: 'Supportive, wearable comfort with refined styling that looks elevated on foot.',
      badges: ['Comfort', 'Polished'],
    },
    sections: {
      background: 'Taryn Rose is built around comfort that still looks good. The product is designed to feel supportive and wearable while keeping a clean, elevated aesthetic.',
      vision: 'Make comfort feel premium. Soft materials, thoughtful construction, and styling that fits a modern lifestyle without sacrificing support.',
      marketing: 'We focus on benefit-led storytelling. Comfort features communicated clearly, paired with refined visuals that keep the brand elevated. We also highlight wearability across day-to-night use cases.',
      retailFit: 'Great for department, comfort-driven specialty adjacencies, and off-price channels that want comfort product with a more elevated appearance.',
    },
    cta: {
      title: 'Need comfort product with a refined look?',
      body: 'We can show you the Taryn Rose direction and how we build comfort assortments by season.',
      buttonText: 'Contact Us',
    },
    coverImage: '/brands/brand-cards/taryn-rose.jpg',
    logoImage: '/brands/logos/taryn-rose.png',
    // Theme colors - Soft blush, comfort-luxury
    accentColor: '#D4A59A',
    tintColor: '#6a4a48',      // Warm rose/blush tint
    glowColor: '#E4B5AA',
  },
  {
    slug: 'jason-wu',
    name: 'Jason Wu',
    type: 'licensed',
    genderProgram: 'Women\'s',
    positioning: 'Modern, refined, fashion-led, clean silhouettes',
    hero: {
      eyebrow: 'Modern Refinement',
      headline: 'Fashion-led design with clean sophistication',
      subhead: 'Minimal, modern silhouettes with refined details and a confident, editorial feel.',
      badges: ['Modern', 'Refined'],
    },
    sections: {
      background: 'Jason Wu sits in a more fashion-led space. The focus is on modern refinement, clean lines, and a premium look that still feels wearable and intentional.',
      vision: 'Deliver modern classics with a sharper point of view. Strong silhouettes, refined proportion, and detail that feels designed, not added.',
      marketing: 'We market with an editorial approach. Minimal layouts, high-quality imagery, and a focus on silhouette. We highlight hero styles and seasonal drops that feel curated rather than crowded.',
      retailFit: 'Best suited for department and off-price programs that want a more fashion-forward, refined aesthetic, with controlled assortment architecture.',
    },
    cta: {
      title: 'Exploring Jason Wu footwear?',
      body: 'Reach out and we\'ll share how we structure the line, the seasonal direction, and ideal channel fit.',
      buttonText: 'Contact Us',
    },
    coverImage: '/brands/brand-cards/jason-wu.jpg',
    logoImage: '/brands/logos/jason-wu.png',
    // Theme colors - Cool slate, modern minimalism
    accentColor: '#7A8B99',
    tintColor: '#3a4a58',      // Cool slate/charcoal tint
    glowColor: '#8A9BAA',
  },
  {
    slug: 'cloud-air',
    name: 'Cloud Air',
    type: 'in_house',
    genderProgram: 'All Genders',
    positioning: 'Trend-right value with comfort and broad appeal',
    hero: {
      eyebrow: 'In-House Brand',
      headline: 'Comfort and value built for daily wear',
      subhead: 'Broad, commercial product with trend-right design and accessible pricing across genders and ages.',
      badges: ['Comfort', 'Value'],
    },
    sections: {
      background: 'Cloud Air is one of our in-house brands built for wide retail reach. We focus on comfort, value engineering, and trend-right styling that stays commercial.',
      vision: 'Create product that works everywhere. Easy silhouettes, modern tooling, and comfort that customers feel immediately.',
      marketing: 'We market Cloud Air with clear benefits and clean presentation. Strong product photography, comfort callouts, and seasonal capsules that help retailers build a focused assortment without overcomplication.',
      retailFit: 'Ideal for mass, family footwear, sporting-goods adjacencies, and off-price programs that want comfort-forward product with broad commercial appeal.',
    },
    cta: {
      title: 'Interested in Cloud Air?',
      body: 'Tell us your price point and channel, and we\'ll map out the right assortment direction.',
      buttonText: 'Contact Us',
    },
    coverImage: '/brands/brand-cards/cloud-air.jpg',
    logoImage: '/brands/logos/cloud-air.png',
    // Theme colors - Sky blue, airy, clouds, comfort
    accentColor: '#8BB5D0',
    tintColor: '#4a6a8a',      // Sky blue tint - airy feel
    glowColor: '#9BC5E0',
  },
  {
    slug: 'sunday-walks',
    name: 'Sunday Walks',
    type: 'in_house',
    genderProgram: 'All Genders',
    positioning: 'Casual lifestyle, easy comfort, weekend-ready',
    hero: {
      eyebrow: 'In-House Brand',
      headline: 'Easy lifestyle footwear for off-duty days',
      subhead: 'Casual, comfortable product designed for everyday routines, weekends, and repeat wear.',
      badges: ['Lifestyle', 'Comfort'],
    },
    sections: {
      background: 'Sunday Walks is built around easygoing lifestyle comfort. Think simple silhouettes, soft materials, and clean looks that feel relaxed but still updated.',
      vision: 'Make casual footwear feel modern and effortless. Comfortable underfoot, easy to style, and dependable across seasons.',
      marketing: 'We market with lifestyle storytelling. Warm, natural imagery and product shots that show real use. We also build small seasonal updates that keep the line feeling fresh while maintaining continuity.',
      retailFit: 'Strong fit for family footwear, mass programs, and off-price assortments that want casual lifestyle comfort with broad customer reach.',
    },
    cta: {
      title: 'Want to see Sunday Walks direction?',
      body: 'We can share seasonal concepts, core silhouettes, and how we build value-driven assortments at scale.',
      buttonText: 'Contact Us',
    },
    coverImage: '/brands/brand-cards/sunday-walks.jpg',
    logoImage: '/brands/logos/sunday-walks.png',
    // Theme colors - Sage green, natural, weekend outdoors
    accentColor: '#8FA882',
    tintColor: '#4a5a42',      // Forest/sage green tint
    glowColor: '#9FB892',
  },
  {
    slug: 'serene-island',
    name: 'Serene Island',
    type: 'in_house',
    genderProgram: 'All Genders',
    positioning: 'Resort ease, relaxed comfort, clean and airy',
    hero: {
      eyebrow: 'In-House Brand',
      headline: 'Relaxed comfort with a resort-ready feel',
      subhead: 'Light, easy footwear designed for warm weather, travel, and everyday comfort.',
      badges: ['Resort', 'Easy Comfort'],
    },
    sections: {
      background: 'Serene Island is designed for relaxed, warm-weather living. The styling is clean and airy, built around comfort and an easy, vacation-adjacent feel.',
      vision: 'Make warm-weather footwear feel simple and elevated. Clean lines, soft materials, and product that feels effortless to wear.',
      marketing: 'We market with bright, minimal storytelling and clean product presentation. We highlight travel and lifestyle moments, and we keep the assortment easy to shop with clear category grouping.',
      retailFit: 'Great for mass, family footwear, and off-price programs that want casual warm-weather product with broad appeal.',
    },
    cta: {
      title: 'Building warm-weather programs?',
      body: 'Let us know your channel and we\'ll suggest the right Serene Island silhouettes and assortment mix.',
      buttonText: 'Contact Us',
    },
    coverImage: '/brands/brand-cards/serene-island.jpg',
    logoImage: '/brands/logos/serene-island.png',
    // Theme colors - Teal/turquoise, tropical resort
    accentColor: '#6A9B9E',
    tintColor: '#3a5a5a',      // Deep teal tint - tropical water
    glowColor: '#7AABAE',
  },
  {
    slug: 'arctic-plunge',
    name: 'Arctic Plunge',
    type: 'in_house',
    genderProgram: 'Kids + Adults (All Genders)',
    positioning: 'Cold-weather utility with modern styling',
    hero: {
      eyebrow: 'In-House Brand',
      headline: 'Winter-ready product with real utility',
      subhead: 'Cold-weather footwear designed for traction, warmth cues, and everyday winter wear at value.',
      badges: ['Cold Weather', 'Utility'],
    },
    sections: {
      background: 'Arctic Plunge is our cold-weather focused in-house concept. The product reads functional and modern, built around winter needs while keeping a clean, commercial look.',
      vision: 'Create winter footwear that feels tough and practical, while still looking current. Simple, strong silhouettes that work across broad customer bases.',
      marketing: 'We market with performance cues and clear benefit communication. Traction, lining stories, and weather-ready positioning, supported by bold, high-contrast imagery that shows utility and confidence.',
      retailFit: 'Strong for family footwear, mass programs, and off-price winter buys where cold-weather product needs to be scalable and commercial.',
    },
    cta: {
      title: 'Planning winter assortments?',
      body: 'We can share Arctic Plunge seasonal direction and how we build winter programs for volume and speed.',
      buttonText: 'Contact Us',
    },
    coverImage: '/brands/brand-cards/arctic-plunge.jpg',
    logoImage: '/brands/logos/arctic-plunge.png',
    // Theme colors - Icy blue, winter, cold crisp
    accentColor: '#7AAFC4',
    tintColor: '#3a5a6a',      // Icy winter blue tint
    glowColor: '#8ABFD4',
  },
  {
    slug: 'modern-rebel',
    name: 'Modern Rebel',
    type: 'in_house',
    genderProgram: 'Teens + Adults (All Genders)',
    positioning: 'Street-driven, bold, trend-led casual',
    hero: {
      eyebrow: 'In-House Brand',
      headline: 'Street-led style with commercial edge',
      subhead: 'Trend-driven casual footwear with bold attitude, designed to feel current and expressive.',
      badges: ['Street', 'Trend-Led'],
    },
    sections: {
      background: 'Modern Rebel is built for a more trend-led customer. The look is bolder, more expressive, and rooted in street-driven casual styling while staying scalable and wearable.',
      vision: 'Deliver trend energy without sacrificing sell-through. Strong silhouettes, confident design cues, and a clean assortment structure that retailers can build around.',
      marketing: 'We market with modern, high-impact visuals and strong silhouette focus. Social-ready presentation, campaign-style drops, and clear style stories that make the assortment feel intentional.',
      retailFit: 'Best for mass, off-price, and specialty adjacencies that want street-driven casual product with broad price accessibility.',
    },
    cta: {
      title: 'Interested in Modern Rebel?',
      body: 'Tell us your customer and we\'ll align the silhouette mix and seasonal direction.',
      buttonText: 'Contact Us',
    },
    coverImage: '/brands/brand-cards/modern-rebel.jpg',
    logoImage: '/brands/logos/modern-rebel.png',
    // Theme colors - Bold red, street, edgy energy
    accentColor: '#C45C5C',
    tintColor: '#5a2a2a',      // Deep red/burgundy tint
    glowColor: '#D46C6C',
  },
];

// Brand categories for filtering
export const brandCategories = [
  'All',
  'Licensed',
  'In-House',
  'Women\'s',
  'Kids',
  'Men\'s',
  'All Genders',
  'Comfort',
  'Fashion',
  'Athletic',
];

// Get brand by slug
export const getBrandBySlug = (slug) => {
  return brands.find(brand => brand.slug === slug);
};

// Get brands by type
export const getBrandsByType = (type) => {
  if (type === 'All') return brands;
  if (type === 'Licensed') return brands.filter(brand => brand.type === 'licensed');
  if (type === 'In-House') return brands.filter(brand => brand.type === 'in_house');
  return brands;
};
